import { CheckCircle, UsersThree, Clock, Warning, Prohibit, Archive, Sparkle } from "@phosphor-icons/react";

/**
 * Community-dataset & parameter-concept statuses:
 *  published, expert_validated, under_review, pending_expert,
 *  retracted, archived, missing (concepts with no submissions)
 */
export const STATUS_META = {
    published: {
        label: "Published", icon: CheckCircle,
        bg: "#DCFCE7", border: "#16A34A", text: "#166534",
    },
    expert_validated: {
        label: "Expert Validated", icon: Sparkle,
        bg: "#DBEAFE", border: "#2563EB", text: "#1E3A8A",
    },
    community_validated: {
        label: "Community Validated", icon: UsersThree,
        bg: "#E9D8FD", border: "#6B46C1", text: "#4C1D95",
    },
    under_review: {
        label: "Under Review", icon: Clock,
        bg: "#FEF9C3", border: "#EAB308", text: "#713F12",
    },
    pending_expert: {
        label: "Pending Expert", icon: Clock,
        bg: "#FFEDD5", border: "#F97316", text: "#9A3412",
    },
    retracted: {
        label: "Retracted", icon: Prohibit,
        bg: "#FEE2E2", border: "#DC2626", text: "#7F1D1D",
    },
    archived: {
        label: "Archived", icon: Archive,
        bg: "#F4F4F5", border: "#71717A", text: "#3F3F46",
    },
    missing_data: {
        label: "Missing Data", icon: Warning,
        bg: "#FFEDD5", border: "#F97316", text: "#9A3412",
    },
    missing: {
        label: "Missing", icon: Warning,
        bg: "#FFEDD5", border: "#F97316", text: "#9A3412",
    },
    verified: {
        label: "Verified", icon: CheckCircle,
        bg: "#DCFCE7", border: "#16A34A", text: "#166534",
    },
};

export default function StatusBadge({ status, size = "md", withIcon = true, testId }) {
    const meta = STATUS_META[status] || STATUS_META.under_review;
    const Icon = meta.icon;
    const cls =
        size === "sm" ? "text-[10px] px-1.5 py-0.5" :
        size === "lg" ? "text-xs px-3 py-1" :
        "text-[11px] px-2 py-0.5";
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center gap-1 font-semibold uppercase tracking-wider rounded-sm border ${cls}`}
            style={{ background: meta.bg, borderColor: meta.border, color: meta.text }}
        >
            {withIcon && <Icon size={size === "lg" ? 14 : 11} weight="fill" />}
            {meta.label}
        </span>
    );
}
